/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import InputWithActions from 'shared/ui/components/form-components/InputWithActions.vue';
import MetadataCategoryFields from './MetadataCategoryFields.vue';
import SecondaryToolbar from 'shared/ui/components/form-components/SecondaryToolbar.vue';

const __vue_script__ = {
    name: 'MetadataFields',

    components: {
        Draggable,
        DropdownMenu,
        ExpandableContent,
        InputWithActions,
        MetadataCategoryFields,
        SecondaryToolbar,
    },

    props: {
        event: {
            type: Object,
            required: true,
        },

        fpType: {
            type: String,
            required: true,
        },

        type: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            eid: this.event._id,
            createdCategory: undefined,
            saving: false,
            editCategory: '',
            editCategoryTitle: '',
            fieldsLimit: this.event.metadata_fields_limit || 0
        };
    },

    computed: {
        categories: {
            get() {
                return this.$store.state.metadataEditor.categories;
            },

            set(categories) {
                this.$store.commit('reorderMetadataCategories', categories);
            }
        },

        changed() {
            return this.$store.state.metadataEditor.changed;
        },

        representationFields() {
            return this.$store.state.metadataEditor.representationFields;
        },

        categoryNameButtonLabel() {
            return this.createdCategory === this.editCategory
                ? this.$t('general.create')
                : this.$t('general.accept');
        },

        showFields() {
            return !this.type?._hide_metadata_fields;
        },

        fieldsLimitReached() {
            if (this.fieldsLimit === 0) {
                return false;
            }

            const fieldsCount = this.categories.reduce((acc, { fields }) => acc + fields.length, 0);

            return fieldsCount >= this.fieldsLimit;
        },

        disableAddFieldButton() {
            return this.fieldsLimitReached;
        },

        addButtonTooltip() {
            if (this.fieldsLimitReached) {
                return this.$t('metadata_editor.fields_limit_reached', [this.fieldsLimit]);
            }

            return null;
        }
    },

    watch: {
        type: {
            immediate: true,
            handler(type) {
                this.$store.commit('setTypeMetadata', {
                    eid: this.eid,
                    representations: this.$utils.metadata.REPRESENTATIONS,
                    type,
                });
            }
        },
    },

    methods: {
        onDragStart() {
            this.drag = true;
        },

        onDragEnd() {
            this.drag = false;
        },

        /** @type {(category: string) => string} */
        categoryLabel(category) {
            return category === 'other'
                ? this.$t('metadata_editor.no_category')
                : this.$utils.strings.capitalize(category);
        },

        addCategory() {
            const tempName = `NEW_CATEGORY_${this.categories.length}`;
            this.$store.commit('addMetadataCategory', tempName);
            this.editCategory = tempName;
            this.createdCategory = tempName;
        },

        /** @param {string} category */
        addField(category) {
            // open category if not open so that field is visibly added
            const header = this.$refs[`expandable-header-${category}`][0];
            const expandableClassList = header?.parentElement?.parentElement?.classList;
            if (header && expandableClassList && !expandableClassList.contains('open')) {
                header.click();
            }
            this.$store.commit('addMetadataField', category);
            setTimeout(() => {
                this.$store.commit('resetFocusedField');
            }, 1000);
        },

        async onSubmit() {
            try {
                if (!this.changed || this.saving) {
                    return;
                }

                this.saving = true;

                const type = this.getTypeDefinitions();
                const { updated, ...errors } = await this.$services.metadata.saveFpTypeMetadata(
                    this.eid, this.fpType, type, this.representationFields
                );

                this.afterSave(updated, errors);

            } catch (error) {
                console.error('[MetadataFields] Error saving metadata', error.message);
                this.showError(this.$t('metadata_editor.unknown_save_error'));

            } finally {
                this.saving = false;
            }
        },

        /**
         * Retrieves the type definitions for the metadata fields.
         * This method is used to fetch and return the type definitions
         * that are necessary for the metadata fields in the application.
         *
         * @returns {Object} The type definitions for the metadata fields.
         */
        getTypeDefinitions() {
            const type = {};
            // keep non keys that are neither representation nor fields
            for (const [key, value] of Object.entries(this.type)) {
                if (this.$utils.metadata.isFieldTechnical(key)) {
                    type[key] = value;
                }
            }

            // cloning categories like this is necessary, vuex complains about mutations
            // other ways such as "[...this.categories]" do not work
            const categories = JSON.parse(JSON.stringify(this.categories));
            let order = 0;
            // add categories and fields that are not deleted + set order
            for (const { fields, _to_delete } of categories) {
                if (!_to_delete) {
                    for (const { field, definition } of fields) {
                        if (!definition._to_delete) {
                            definition.order = order;
                            order++;
                            type[field] = definition;
                        }
                    }
                }
            }

            return type;
        },

        /** @param {Record<string,unknown>} type the updated type */
        afterSave(type, errors) {
            if (type) {
                this.$notify({
                    group: 'flashes',
                    text: this.$t('metadata_editor.save_success'),
                    type: 'success',
                    duration: 5000
                });
                this.$store.commit('resetChanged');
                this.$store.commit('setTypeMetadata', {
                    eid: this.eid,
                    representations: this.$utils.metadata.REPRESENTATIONS,
                    type,
                });
            } else if (errors?.invalidFieldNames) {
                this.showError(this.$t('metadata_editor.invalid_field_name') + ': ' + errors.invalidFieldNames.join(', '));
            } else if (errors?.mayNotBePrivate) {
                this.showError(this.$t('metadata_editor.field_may_not_be_private') + ': ' + errors.mayNotBePrivate.join(', '));
            } else if (errors?.metadataWasChanged) {
                this.showError(this.$t('metadata_editor.has_been_modified'));
            } else {
                this.showError(this.$t('metadata_editor.unknown_save_error'));
            }
        },

        /** @param {string} errorMessage */
        showError(errorMessage) {
            this.$modal.show('dialog', {
                title: this.$t('metadata_editor.invalid_data'),
                text: errorMessage,
                buttons: [{
                    title: this.$t('metadata_editor.ok'),
                    handler: async () => {
                        this.$modal.hide('dialog');
                        this.saving = false;
                    },
                    class: 'btn'
                }],
            });
        },

        renameCategory(category) {
            this.editCategory = category;
            this.editCategoryTitle = this.categoryLabel(category);
        },

        /** @type {(category: string) => boolean} */
        hasUnchangeableFields(category) {
            const isPrivate = ({ field }) => field.startsWith('fp_');
            const isNotEditable = ({ definition }) => definition?._editable === false;
            const hasCustomController = ({ definition }) => Boolean(definition?.kind === 'custom' && definition?.kind_options && definition?.kind_options.controller);
            const fields = this.categories.find(d => d.category === category)?.fields || [];
            return fields.some(d => isPrivate(d) || isNotEditable(d) || hasCustomController(d));
        },

        closeDropDown() {
            const dropDowns = this.$refs['dropDownMenu'];
            if (Array.isArray(dropDowns)) {
                for (const dd of dropDowns) {
                    if (dd.hide) {
                        dd.hide();
                    }
                }
            }
        },

        /** @param {string} category */
        toggleDeletedCategory(category) {
            this.closeDropDown();
            const wasDeleted = this.categories.find(d => d.category === category)?._to_delete;
            if (this.hasUnchangeableFields(category) && !wasDeleted) {
                this.$modal.show('dialog', {
                    title: this.$t('metadata_editor.can_not_delete_category'),
                    text: this.$t('metadata_editor.can_not_delete_category_text'),
                    buttons: [
                        {
                            title: this.$t('general.cancel'),
                            handler: () => this.$modal.hide('dialog'),
                            class: 'btn',
                        },
                    ],
                });
                return;
            }
            this.$store.commit('toggleDeletedCategory', category);
        },

        stopNameEditing() {
            this.editCategory = '';
            this.editCategoryTitle = '';
        },

        updateCategoryName() {
            this.$store.commit(
                'updateCategoryName',
                {
                    oldCategory: this.editCategory,
                    newCategory: this.editCategoryTitle
                },
            );
            this.stopNameEditing();
        }

    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata-fields"},[_c('h4',[_vm._v(_vm._s(_vm.$t('metadata_editor.fields')))]),(!_vm.showFields)?_c('p',{staticClass:"editor-caption"},[_vm._v(_vm._s(_vm.$t('metadata_editor.fields_hidden', [_vm.fpType])))]):[_c('draggable',{staticClass:"metadata-category-list",attrs:{"handle":".drag-handle"},on:{"start":_vm.onDragStart,"end":_vm.onDragEnd},model:{value:(_vm.categories),callback:function ($$v) {_vm.categories=$$v},expression:"categories"}},_vm._l((_vm.categories),function(ref,categoryIndex){
var category = ref.category;
var fields = ref.fields;
var _to_delete = ref._to_delete;
return _c('div',{staticClass:"metadata-fields-category",class:{ 'category-to-delete': _to_delete }},[_c('expandable-content',{attrs:{"is-open":category !== _vm.createdCategory && !_to_delete,"unlimited-height":true,"clickable-header":!_to_delete,"show-toggler":_vm.editCategory !== category && !_to_delete}},[_c('div',{ref:("expandable-header-" + category),refInFor:true,staticClass:"expandable-content-header",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"drag-handle"},[_c('i',{staticClass:"icon-reorder"})]),(_vm.editCategory === category)?_c('div',{staticClass:"category-name editing"},[_c('validation-provider',{attrs:{"slim":true,"name":"category-name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-actions',{attrs:{"type":"text","name":"category-name","autofocus":true,"placeholder":_vm.$t('metadata_editor.enter_category_name'),"errors":errors},model:{value:(_vm.editCategoryTitle),callback:function ($$v) {_vm.editCategoryTitle=$$v},expression:"editCategoryTitle"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.stopNameEditing()}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.updateCategoryName()}}},[_vm._v(_vm._s(_vm.categoryNameButtonLabel))])])]}}],null,true)})],1):_c('h5',[_vm._v(_vm._s(_vm.categoryLabel(category)))])]),_c('span',{staticClass:"expendable-content-actions",attrs:{"slot":"actions"},slot:"actions"},[(_vm.editCategory !== category)?_c('dropdown-menu',{ref:"dropDownMenu",refInFor:true,staticClass:"embedded"},[_c('ul',[_c('li',[_c('a',{staticClass:"rename",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.renameCategory(category)}}},[_c('i',{staticClass:"ic-edit"}),_vm._v(_vm._s(_vm.$t('general.rename')))])]),_c('li',[_c('a',{class:{ 'danger': !_to_delete, 'success': _to_delete },attrs:{"href":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleDeletedCategory(category)}}},[_c('i',{class:{'ic-trash-2': !_to_delete, 'ic-restore': _to_delete }}),_vm._v(_vm._s(_to_delete ? _vm.$t('metadata_editor.restore') : _vm.$t('general.delete')))])])])]):_vm._e()],1),(!_to_delete)?_c('metadata-category-fields',{attrs:{"category-index":categoryIndex,"add-field":_vm.addField,"fp-type":_vm.fpType}}):_vm._e()],1)],1)}),0),_c('secondary-toolbar',[_c('div',{staticClass:"contextual"},[(_vm.categories.length === 1)?_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.addButtonTooltip),expression:"addButtonTooltip"}],staticClass:"btn btn-ctx-icon",attrs:{"type":"button","disabled":_vm.disableAddFieldButton},on:{"click":function($event){return _vm.addField(_vm.categories[0].category)}}},[_vm._v(_vm._s(_vm.$t('metadata_editor.add_field'))),_c('i',{staticClass:"ic-plus"})]):_vm._e(),(_vm.categories.length > 1)?_c('dropdown-menu',{attrs:{"anchor-pos":"sw","hide-delay-after-click":0,"disabled":_vm.disableAddFieldButton},scopedSlots:_vm._u([{key:"toggler",fn:function(ref){return [_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.addButtonTooltip),expression:"addButtonTooltip"}],staticClass:"btn btn-ctx-icon",attrs:{"type":"button","disabled":_vm.disableAddFieldButton}},[_vm._v(_vm._s(_vm.$t('metadata_editor.add_field'))),_c('i',{staticClass:"ic-plus"})])]}}],null,false,1441908880)},[_c('ul',_vm._l((_vm.categories),function(category){return _c('li',[_c('a',{on:{"click":function($event){return _vm.addField(category.category)}}},[_vm._v(_vm._s(_vm.categoryLabel(category.category)))])])}),0)]):_vm._e(),_c('button',{staticClass:"btn btn-ctx-icon",attrs:{"type":"button"},on:{"click":_vm.addCategory}},[_vm._v(_vm._s(_vm.$t('metadata_editor.add_category'))),_c('i',{staticClass:"ic-plus"})])],1),_c('a',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.saving},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.$t('metadata_editor.save_changes')))])])]],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetadataFields.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__